import React from 'react';
import { Select } from 'antd';

const SelectExpressionOperator = ({ ...rest }) => {
  return (
    <Select {...rest} allowClear>
      <Select.Option value="greaterThan">Maior</Select.Option>
      <Select.Option value="greaterThanOrEqual">Maior ou igual</Select.Option>
      <Select.Option value="lessThan">Menor</Select.Option>
      <Select.Option value="lessThanOrEqual">Menor ou igual</Select.Option>
      <Select.Option value="equals">Igual</Select.Option>
    </Select>
  );
};

export default SelectExpressionOperator;
